const BLANK_PATTERN = /\[[^[\]\n]{1,80}\]/g;

// Unique square-bracket blanks such as [aligner #], in the order they first appear.
export function findUnfilledBlanks(text: string): string[] {
    return [...new Set(text.match(BLANK_PATTERN) ?? [])];
}
